/**
 * Checks if a numeric value is > 0 and returns it as a string.
 * Returns undefined if no value is passed or the value equals 0.
 *
 * @param count
 * @returns number as a string or undefined
 */
export const itemCountToString = (count?: number): string | undefined =>
  count && count > 0 ? count.toString() : undefined;
